if(!customElements.get('animated-text')){
    class AnimatedText extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.texts = this.querySelectorAll('.heading, .body-text');

            this.onVisibilityChange();
            window.addEventListener("scroll", debounce(this.onVisibilityChange.bind(this)), 200);
            window.addEventListener("resize", debounce(this.onVisibilityChange.bind(this)), 200);
        }

        setParallaxEffect(){
            const textParallaxElements = this.querySelectorAll('[data-text-parallax="true"]');
            textParallaxElements.forEach(item => {
                const letters = item.querySelectorAll('.char');
                letters.forEach(l => {
                    l.addEventListener('mousemove', (e) => {
                        this.charParallaxEffect(e, l);
                    }); 
                    l.addEventListener('mouseout', (e) => {
                        setTimeout(() => {
                            this.charClearParallaxEffect(l);
                        }, 300);
                    });
                });
            });
        }

        charParallaxEffect(e, wrapper){
            const rect = wrapper.getBoundingClientRect();
            const xPos = e.clientX - rect.left;
            const yPos = e.clientY - rect.top;

            const amountMovedX = (xPos - rect.width / 2) * -0.1; // small movement
            const amountMovedY = (yPos - rect.height / 2) * -0.1;

            wrapper.style.transform = `translate(${amountMovedX}px, ${amountMovedY}px) scale(1.05)`;
        };

        charClearParallaxEffect(wrapper){
            wrapper.style.transform = `translate(0px, 0px) scale(1)`;
        }

        onVisibilityChange(){
            const visibleElement = isPartialElementInViewport(this);
            const loaded = this.dataset.loaded === 'true';

            if(visibleElement && !loaded){
                this.addAnimation();
                this.setAttribute('data-loaded', 'true');
            }
        }

        addAnimation(){
            this.texts.forEach(item => {
                const animationDelay = parseInt(item.dataset.animationDelay);
                const animationType = item.dataset.animationType;
                const text = item.dataset.text;

                if(text.trim() !== ''){
                    if(animationType === 'slide-in'){
                        item.innerHTML = this.slideInSequence(text.trim(), animationDelay);
                        setTimeout(() => {
                            this.setParallaxEffect();
                        }, animationDelay);
                    }else if(animationType === 'typing'){
                        this.typingEffect(text.trim(), animationDelay, item);
                    }else if(animationType === 'slide-in-from-bottom'){
                        this.slideInFromBottom(text, animationDelay, item);
                        this.setParallaxEffect();
                    }
                }
            });
        }

        slideInSequence(text, animationDelay){
            const letters = text.split('');
            return letters.map((l, i) => {
                const delay = i * 0.05;
                return `<span class="char-wrapper" style="animation-delay:${delay + (animationDelay * 0.001)}s; ${l.trim() === ''? 'padding-inline: 0.15em' : ''}"><span class="char ${l.trim() === ''? 'space': ''}">${l}</span></span>`
            }).join('');
        }

        typingEffect(text, animationDelay, item){
            [...text].forEach((l, i) => {
                const speed = 50;
                setTimeout(() => {
                    if(i === 0) item.innerHTML = '';
                    const span = document.createElement('span');
                    span.classList.add('char');
                    if(l.trim() === ''){
                        span.classList.add('space');
                    }
                    span.textContent = l;
                    item.appendChild(span);

                    this.setParallaxEffect();
                }, animationDelay + (speed * i));
            });
        }

        slideInFromBottom(text, animationDelay, item){
            item.innerHTML = '';

            const span = document.createElement('span');
            span.style.whiteSpace = 'pre-wrap';
            span.style.visibility = 'hidden';
            span.style.position = 'absolute';
            span.style.width = '100%';
            span.textContent = text;
            item.appendChild(span);

            const range = document.createRange();
            range.selectNodeContents(span);

            const lines = [];

            let lastTop = null;
            let currentLine = [];

            for(let i = 0; i < text.length; i++){
                range.setStart(span.firstChild, i);
                range.setEnd(span.firstChild, i + 1);
                const rect = range.getBoundingClientRect();

                if(lastTop === null || Math.abs(rect.top - lastTop) < 1){
                    currentLine.push(text[i]);
                }else{
                    lines.push(currentLine.join(''));
                    currentLine = [text[i]];
                }

                lastTop = rect.top;
            }
            
            if(currentLine.length){
                lines.push(currentLine.join(''));
            }

            item.removeChild(span);
            
            lines.forEach((line, i) => {
                const div = document.createElement('div');
                div.classList.add('line', 'overflow-hidden');

                const childSpan = document.createElement('span');
                childSpan.style.animationDelay = `${(animationDelay + i * 200) / 1000}s`;

                const letters = line.split('');
                letters.forEach((l, i) => {
                    const innerSpan = document.createElement('span');
                    innerSpan.classList.add('char');
                    if(l.trim() === ''){
                        innerSpan.classList.add('space');
                    }
                    innerSpan.textContent = `${l}`;
                    childSpan.appendChild(innerSpan);
                });

                div.appendChild(childSpan);
                
                item.appendChild(div);
            });
        }
    }

    customElements.define('animated-text', AnimatedText);
}